import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { LiveEventViewModel, UserAuthenticationViewModel, ChatHistoryViewModel, UserViewModel, TapBackViewModel, GroupedTapBackViewModel, EventViewModel } from 'src/app/_models/generatedModels';
import { HubConnection } from '@microsoft/signalr';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ChatViewModel, EventRole, GoogleObj } from 'src/app/_models/models';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { EventService } from 'src/app/_services/generatedServices';
import { throws } from 'assert';
import { GoogleTranslateService } from 'src/app/_services/googleTranslate.service';
import { runInThisContext } from 'vm';
import { ToasterService } from 'src/app/_services/toaster.service';
declare var UAParser: any;
//https://www.neoito.com/blog/how-to-maintain-scroll-position-in-angular-chat-app/
//https://stackoverflow.com/questions/35232731/angular-2-scroll-to-bottom-chat-style

@Component({
  selector: 'live-event-chat',
  templateUrl: 'live-event-chat.component.html',
})
export class LiveEventChatComponent implements OnInit, AfterViewInit {
  initialized = false;
  @Input() event: LiveEventViewModel;
  @Input() connection: HubConnection;
  @Input() hideCarat: boolean = false;
  @Input() role: EventRole;
  public EventRole = EventRole;

  @ViewChild('messageContainer') private messageContainer: ElementRef;
  @ViewChild('chatbox') private chatbox: ElementRef;

  public user: UserAuthenticationViewModel;
  public messages: ChatViewModel[] = new Array();
  public existingMessages: ChatHistoryViewModel[] = new Array();
  public pinnedMessages: ChatViewModel[] = new Array();
  public chatMessage: string;
  toggled: boolean = false;
  showPicker: boolean = false;
  loadError: boolean = false;
  loading: boolean = false;
  userScrolledUp: boolean = false;
  newMessagesSinceScrollUp: boolean = false;

  @Output()
  resized = new EventEmitter();

  @Output()
  collapse = new EventEmitter();
  isNearBottom: boolean;
  isMobile: boolean;

  constructor(private auth: AuthenticationService, private eventService: EventService, private googleTranslateService: GoogleTranslateService, private toaster: ToasterService) {}

  ngAfterViewInit(): void {
    of(null)
      .pipe(delay(5000))
      .subscribe((result) => {
        this.onResize(null);
        this.scrollToBottom(false);
      });
  }

  reload() {
    this.loading = true;
    this.eventService.getChatHistory(this.event.id).subscribe(
      (result) => {
        this.existingMessages = result;
        this.updatePinnedMessages();
        this.initialized = true;
        this.loadError = false;
        this.loading = false;
        this.scrollToBottom(false);
      },
      (error) => {
        this.loadError = true;
        this.loading = false;
      }
    );
  }

  ngOnInit(): void {
    this.user = this.auth.getUser();
    this.isMobile = this.isMobileDevice();

    this.connection.on('postChat', (id: number, name: string, message: string, userId: number, eventId: number) => {
      if (eventId === this.event.id) {
        var model = new ChatViewModel(id, name, message, userId);

        let regexp = new RegExp('>(https://behaviorlive.com/events/|https://behaviorlive.com/courses/|https://behaviorlive.com/on-demand/)(.*)<');
        var result = regexp.exec(message);

        if (result) {
          model.eventLink = result != null;
          model.eventLinkId = result[2];
        }

        if (this.auth.isSuperUser()) {
          var goog = new GoogleObj();
          goog.q = [model.message];
          goog.target = 'en';
          this.googleTranslateService.translate(goog).subscribe((result) => {
            if (result.data && result.data.translations && result.data.translations.length > 0 && result.data.translations[0].detectedSourceLanguage != 'en') {
              model.message += '<br>-----<br>' + result.data.translations[0].translatedText;
            }
          });
        }

        this.messages.push(model);
        this.scrollToBottom(true);
      }
    });

    this.connection.on('tapBack', (id: number, tapBacks: GroupedTapBackViewModel[], eventId: number) => {
      if (eventId === this.event.id) {
        var index = this.messages.findIndex((x) => x.id == id);
        if (index != -1) {
          this.messages[index].tapBacks = tapBacks;
          this.updatePinnedMessages();
          this.scrollToBottom(false);
          return;
        }

        var index2 = this.existingMessages.findIndex((x) => x.id == id);
        if (index2 != -1) {
          this.existingMessages[index2].tapBacks = tapBacks;
          this.updatePinnedMessages();
          this.scrollToBottom(false);
        }
      }
    });

    this.connection.on('pinned', (id: number, pinned: boolean, eventId: number) => {
      if (eventId === this.event.id) {
        var index = this.messages.findIndex((x) => x.id == id);
        if (index != -1) {
          this.messages[index].pinned = pinned;
          this.updatePinnedMessages();
          return;
        }

        var index2 = this.existingMessages.findIndex((x) => x.id == id);
        if (index2 != -1) {
          this.existingMessages[index2].pinned = pinned;
          this.updatePinnedMessages();
        }
      }
    });

    this.connection.on('showToken', (eventId: number, token: string, tokenNumber: number) => {
      if (eventId !== this.event.id) {
        return;
      }
      console.log('show token');
      if (this.isMobileDevice()) {
        console.log('is mobile device');
        return;
      }

      let model = new ChatViewModel(0, 'SYSTEM MESSAGE', `CEU Attendance Check #${tokenNumber} NOW SHOWING at the top of your screen`, 2);
      model.systemMessage = true;
      this.messages.push(model);
      this.scrollToBottom(true);
    });

    this.connection.on('tipReceived', (eventId: number, name: string) => {
      if (eventId !== this.event.id) {
        return;
      }
      let model = new ChatViewModel(0, 'SYSTEM MESSAGE', `${name} just sent a donation. Thank you!`, 2);
      model.systemMessage = true;
      this.messages.push(model);
      this.scrollToBottom(true);
    });

    this.connection.on('resetChat', (eventId: number) => {
      if (eventId !== this.event.id) {
        return;
      }
      this.messages = [];
      this.existingMessages = [];
      this.pinnedMessages = [];
    });

    this.connection.on('removeSingleChat', (id: number, eventId: number) => {
      if (eventId === this.event.id) {
        var index = this.messages.findIndex((x) => x.id == id);
        if (index != -1) {
          this.messages.splice(index, 1);
          this.scrollToBottom(false);
          return;
        }

        var index2 = this.existingMessages.findIndex((x) => x.id == id);
        if (index2 != -1) {
          this.existingMessages.splice(index2, 1);
          this.scrollToBottom(false);
        }
      }
    });

    this.reload();
  }

  updatePinnedMessages() {
    this.pinnedMessages = [ ...this.existingMessages.filter(x => x.pinned).map(historyMsg => {
      const chatViewModel = new ChatViewModel(
        historyMsg.id,
        `${historyMsg.user.firstName} ${historyMsg.user.lastName}`,
        historyMsg.message,
        historyMsg.user.id
      );
      chatViewModel.eventLink = historyMsg.isEventLink;
      chatViewModel.eventLinkId = historyMsg.eventLinkId;
      chatViewModel.pinned = historyMsg.pinned;
      chatViewModel.tapBacks = historyMsg.tapBacks;
      return chatViewModel;
    }),
      ...this.messages.filter(x => x.pinned)
    ];
  }

  click() {
    console.log('clicked');
  }

  tapBack(messageId: number, emojii: string) {
    this.connection.invoke('tapBack', messageId, emojii, this.user.id, this.event.id);
    
  }

  onPinned(messageId: number) {
    this.connection.invoke('pinned', messageId, this.event.id);
  }

  onRemoveSingleChat(messageId: number) {
    this.toaster.confirmDialog('Are you sure you want to remove this chat message?', 'Are you sure?').subscribe((dresult) => {
      if (dresult) {
        this.connection.invoke('removeSingleChat', messageId, this.event.id);
      }
    });
  }

  onCopyAsQuestion(message: any) {
    this.toaster.confirmDialog('Are you sure you want to copy this message to Questions?', 'Are you sure?').subscribe((dresult) => {
      if (dresult) {
        let chatMessage: ChatViewModel;
        if (message instanceof ChatViewModel) {
          chatMessage = message;
        } else {
          chatMessage = new ChatViewModel(message.id, `${message.user.firstName} ${message.user.lastName}`, message.message, message.user.id);
        }

        this.connection.invoke('postQuestion', chatMessage.name, chatMessage.message, chatMessage.userId, this.event.id);
      }
    });
    
  }

  isMobileDevice(): boolean {
    let parser = new UAParser();
    let result = parser.getResult();

    if (result.os.name == 'Mac OS' || result.os.name == 'Windows') return false;

    return true;
  }

  public sendMessage() {
    this.connection.invoke('postChat', this.user.firstName + ' ' + this.user.lastName, this.chatMessage, this.user.id, this.event.id);
    this.chatMessage = null;
  }

  public sendAndTranslate() {
    var message = this.chatMessage;
    var goog = new GoogleObj();
    goog.q = [message];
    goog.target = 'es';
   // goog.target = 'fr';
    this.googleTranslateService.translate(goog).subscribe((result) => {
      this.connection.invoke('postChat', this.user.firstName + ' ' + this.user.lastName, result.data.translations[0].translatedText, this.user.id, this.event.id);
      this.chatMessage = null;
    });
  }

  onScroll(event) {
    this.isNearBottom = this.isUserNearBottom();
    this.userScrolledUp = !this.isNearBottom;
  }

  private isUserNearBottom(): boolean {
    const threshold = 50;
    const position = this.messageContainer.nativeElement.scrollTop + this.messageContainer.nativeElement.offsetHeight;
    const height = this.messageContainer.nativeElement.scrollHeight;
    return position > height - threshold;
  }

  handleSelection(char) {
    if (this.chatMessage == null) {
      this.chatMessage = '';
    }

    this.chatMessage = this.chatMessage + char;
    this.toggled = false;
    this.chatbox.nativeElement.focus();
  }

  public scrollToBottom(newMessage: boolean): void {
    if (this.userScrolledUp && !this.isNearBottom) {
      this.newMessagesSinceScrollUp = newMessage;
      return;
    }

    of(null)
      .pipe(delay(500))
      .subscribe((result) => {
        this.messageContainer.nativeElement.scroll({
          top: this.messageContainer.nativeElement.scrollHeight,
          left: 0,
          behavior: 'smooth',
        });
        this.isNearBottom = true;
        this.newMessagesSinceScrollUp = false;
        this.userScrolledUp = false;
      });
  }

  public manualGoToBottom() {
    this.userScrolledUp = false;
    this.scrollToBottom(false);
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event) {
    let windowHeight = window.innerHeight;
    let messageHeight = this.messageContainer.nativeElement.getBoundingClientRect().top;

    this.messageContainer.nativeElement.style.height = windowHeight - messageHeight - 58 + 'px';
    this.resized.emit();
  }

  collapseChat() {
    this.collapse.emit();
  }
}
